var _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgImageTypeSelected(props) {
  const _id4 = useUniqueInlineId();
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.622 17.025h12.402c.806 0 1.46-.653 1.46-1.46V6.083c0-.806-.654-1.46-1.46-1.46H6.622a1.46 1.46 0 00-1.459 1.46v9.484c0 .806.653 1.459 1.46 1.459z",
    stroke: "url(#".concat(_id, ")"),
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.516 12.648V2.434A1.46 1.46 0 012.975.975h13.131",
    stroke: "url(#".concat(_id2, ")"),
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.742 10.824a1.824 1.824 0 110-3.648 1.824 1.824 0 010 3.648z",
    stroke: "url(#".concat(_id3, ")"),
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.039 17.025L9.014 9l-3.84 3.84",
    stroke: "url(#".concat(_id4, ")"),
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: 20.412,
    y1: 16.909,
    x2: 20.412,
    y2: 4.623,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1253FA"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 16.038,
    y1: 12.538,
    x2: 16.038,
    y2: 0.975,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1253FA"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id3,
    x1: 17.549,
    y1: 10.79,
    x2: 17.549,
    y2: 7.176,
    gradientUnits: "userSpaceOnUse"
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1253FA"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id4,
    x1: 16.983,
    y1: 16.95,
    x2: 16.983,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9"
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1253FA"
  })))));
}
export default SvgImageTypeSelected;